




























































import { get } from 'vuex-pathify';
import { mapActions, mapGetters } from 'vuex';

import { Customer, ICustomer } from '@/models/customer';
import { IFetchCustomerActionPayload } from '@/store/modules/customer';

import mixins from '@/utils/mixins';
import ProxyableMixin from '@/mixins/proxyable';
import FunctionsMixin from '@/mixins/functions';
import { getPropertyFromItem } from '@/utils/helpers';

export default mixins(FunctionsMixin, ProxyableMixin).extend({
  name: 'CustomerSearch',

  data: () => ({
    isLoading: false,
    search: '',
    errorMessage: ''
  }),

  computed: {
    ...mapGetters({
      customers: 'customer/getCustomers'
    }),

    getCustomerById: get<(id: string) => Customer>('customer/getCustomerById'),

    internalValue: {
      get(): ICustomer | string {
        return this.value;
      },
      set(value?: ICustomer | string) {
        this.setValue(value);
      }
    } as any
  },

  mounted() {
    if (this.internalValue) {
      const searchQuery = getPropertyFromItem(
        this.internalValue,
        'identifier',
        this.internalValue
      );
      this.tryGetOrFetchCustomer(searchQuery);
    }
  },

  methods: {
    ...mapActions({
      fetchCustomers: 'customer/fetchCustomers'
    }),

    clearAllErrors(): void {
      this.errorMessage = '';
    },

    clear() {
      this.$emit('clearCustomer');
    },

    async setValue(val: Customer) {
      this.$emit('update:text', val ? String(val.id + ' - ' + val.name) : '');
      this.$emit('select', val);
      this.$emit('input', val ? val.id : null);
      this.$emit('change', val ? val.id : null);
    },

    searchCustomers(params?: IFetchCustomerActionPayload) {
      this.fetchCustomers(params).finally(() => {
        this.isLoading = false;
      });
    },

    debounceFetchCustomers(search: string) {
      this.clearAllErrors();

      // search input is set to null in v-autocomplete
      if (search === null) return;

      this.isLoading = true;

      const params: IFetchCustomerActionPayload = {
        filters: {
          search: search
        }
      };

      this.debounce(this.searchCustomers, 1000)(params);
    },

    /** Disabling vuetify search filtering by overriding the default filter in the v-autocomplete component */
    customerSearchFilter(item: any, queryText: string, itemText: string) {
      // doing this to not use a local filter but filter only from the backend
      return true;
    },

    fetchCustomersIfNoneSelected() {
      if (!this.internalValue) this.searchCustomers();
    },

    tryGetOrFetchCustomer(identifier: string) {
      const customer = this.getCustomerById(identifier);
      if (!customer) {
        this.clearAllErrors();
        this.isLoading = true;
        const params: IFetchCustomerActionPayload = {
          filters: {
            search: identifier
          }
        };

        this.searchCustomers(params);
      }
    }
  }
});
